// extracted by mini-css-extract-plugin
module.exports = {"topNav":"LandingNavbar_topNav__3pGYm","scarpLogo":"LandingNavbar_scarpLogo__2leSV","partnerWrapper":"LandingNavbar_partnerWrapper__ksLMB","link":"LandingNavbar_link__f0L86"};